import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { CallLog } from '../../../../../types/call-logs';
import { getCallOutcomeIcon } from '../../../../../../settings/components/call-outcomes/components/call-outcome-content/helpers/call-outcome-column-data';
import './cells.scss';
import { RootState } from '../../../../../../../store/root-reducer';
import {
  getOptionFromOutcome,
  mapOutcomeToOption,
} from '../../../../../../sequence/components/sequence-single-content/components/sequence-single-contacts/components/prospect-outcome-select/utils/helper';
import GenericCustomOutcomeDropdown from '../../../../../../settings/components/custom-outcomes/components/custom-outcome-dropdown';
import { accessibleOnClick } from '../../../../../../../shared/utils/accessible-on-click';

interface IProps {
  row: CallLog;
  onChangeCallOutcome: (outcomeId: number, CallLogId: number) => void;
  disabled?: boolean;
}

const CallOutcomeCell: React.FC<IProps> = memo(
  ({ row, onChangeCallOutcome, disabled }) => {
    const callOutcomeList = useSelector(
      (state: RootState) => state?.dialer?.getCallOutcomeListResponse ?? [],
    );

    const options = useMemo(() => mapOutcomeToOption(callOutcomeList ?? []), [
      callOutcomeList,
    ]);

    const initialOption = useMemo(
      () => getOptionFromOutcome(callOutcomeList, row.callOutcome?.id),
      [callOutcomeList, row.callOutcome?.id],
    );

    return (
      <div {...accessibleOnClick((e) => e.stopPropagation())}>
        <GenericCustomOutcomeDropdown
          showFooter={false}
          options={options}
          showTotal={false}
          className="call-outcome-dropdown"
          disabled={disabled}
          renderSelectedOutcomeIcon={(option) =>
            getCallOutcomeIcon(
              String(option?.name ?? ''),
              Boolean(option?.isDefault),
              String(option?.sentiment ?? ''),
              { width: 16, height: 16 },
            )
          }
          initialSelectedOption={initialOption}
          optionRenderer={(option) => (
            <div className="d-flex align-items-center">
              {getCallOutcomeIcon(
                String(option?.name ?? ''),
                Boolean(option?.isDefault),
                String(option?.sentiment ?? ''),
                { width: 16, height: 16 },
              )}
              <span className="ml-1">{option?.name}</span>
            </div>
          )}
          onChange={(option) => {
            onChangeCallOutcome(option?.id, row?.id);
          }}
          addOutcomeLabel="Add Call Outcome"
        />
      </div>
    );
  },
);
CallOutcomeCell.displayName = 'CallOutcomeCell';

export default CallOutcomeCell;
